import React, { FunctionComponent, useCallback } from "react";
import { PlusIcon } from "@icons/PlusIcon";
import { MinusIcon } from "@icons/MinusIcon";
import { colors } from "../../../../ui-kit/ConfigProvider/ConfigProvider";
import { useAddRemoveToPlan } from "./useAddRemoveToPlan";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { selectIsHeaderVisible } from "@store/app/appReducer";
import { useAppSelector } from "@store/store";

interface AddRemoveButtonProps {
  id: number;
  type: "Event" | "Place" | "Goal" | "Tour" | "Challenge" | "SelfGuided";
  color?: string;
  variant?: "default" | "small";
  glow?: boolean;
}

const AddRemoveButton: FunctionComponent<AddRemoveButtonProps> = ({
  id,
  type,
  variant = "default",
  glow = false,
}) => {
  const isHeaderVisible = useAppSelector(selectIsHeaderVisible);
  const [onAddOrRemovePlanItem, { isLoading, isAdded }] = useAddRemoveToPlan(
    id,
    type,
  );

  const handleAddOrRemovePlanItem = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onAddOrRemovePlanItem();
    },
    [onAddOrRemovePlanItem],
  );

  if (!isHeaderVisible) {
    return null;
  }

  return (
    <TabButton
      raised={variant === "default"}
      disabled={isLoading}
      onPress={handleAddOrRemovePlanItem}
      label={isAdded ? "Remove" : "Add"}
      variant={variant === "small" ? "default" : "inverse"}
      size={variant === "small" ? "small" : "default"}
      glow={glow}
      iconPrefix={
        isAdded ? (
          <MinusIcon size={18} color={colors.neutral700} />
        ) : (
          <PlusIcon size={18} color={colors.neutral700} />
        )
      }
    />
  );
};

export { AddRemoveButton };
